import React from 'react';

export const globalMenu = {
  activeMain: -1,
  updateMain: ()=>{},
};

export const MenuConext = React.createContext( globalMenu );